import React from 'react'

import BasicTooltip, { BasicTooltipProps } from '../BasicTooltip'
import { LinkContent, LinkText, StyledLink } from '../styled'

interface LinkableTooltipProps extends BasicTooltipProps {
  linkTo: string
}

const LinkableTooltip: React.FC<LinkableTooltipProps> = ({
  contents,
  linkTo,
  openDirection = 'right',
  className = '',
}) => (
  <BasicTooltip
    openDirection={openDirection}
    className={className}
    contents={
      <StyledLink href={linkTo} target={'_blank'}>
        {typeof contents === 'string' ? <LinkContent>{contents}</LinkContent> : contents}
        <LinkText>Click here to learn more.</LinkText>
      </StyledLink>
    }
  />
)

export default LinkableTooltip
